<template>
    <v-container fill-height fluid style="height: 100%">
        <v-card class="d-flex align-center justify-center pa-4 mx-auto"
                max-width="650"
                min-height="76"
                outlined
                fill-height>
            <div :class="`text-xl-h4`" v-show="status.accessingToken">
                Loading...
            </div>

            <div :class="`text-xl-h4`" v-show="status.accessingTokenFailure">Er is iets foutgegaan bij het inloggen.</div>
        </v-card>
    </v-container>
</template>
<script>
    /* eslint-disable */
    import { mapState, mapActions } from "vuex";

    export default {
        name: "Login",
        computed: {
            ...mapState("account", ["status"]),
        },
        created: function () {
            // reset login status
            this.logout();
        },
        mounted: function () {
            let vm = this;
            let token = encodeURIComponent(vm.$route.query.token);
            if (token) {
                this.accessToken({
                    token, successCallback: function () {
                        vm.$router.push('/');
                    }
                });
            }
        },
        methods: {
            ...mapActions("account", ["accessToken", "logout"]),
        },
    };
</script>